import { gsap } from 'gsap';

export default class HeroTextAnimation {
    constructor(options = {}) {
        this.options = {
            heroSelector: '.hero',
            labelSelector: '.hero__label',
            titleSelector: '.hero__title',
            descriptionSelector: '.hero__description',
            offsetY: 20, // pixels to slide up from
            duration: 0.5, // animation duration in seconds
            stagger: 0.3, // delay between each element in seconds
            ...options
        };

        this.hero = document.querySelector(this.options.heroSelector);
        this.label = this.hero?.querySelector(this.options.labelSelector);
        this.title = this.hero?.querySelector(this.options.titleSelector);
        this.description = this.hero?.querySelector(this.options.descriptionSelector);

        this.animated = false;
    }

    init() {
        if (!this.hero) return;

        // Set initial state for all elements
        const elements = [this.label, this.title, this.description].filter(Boolean);
        
        elements.forEach(element => {
            if (element) {
                gsap.set(element, {
                    opacity: 0,
                    y: this.options.offsetY
                });
            }
        });
    }

    animate() {
        if (this.animated || !this.hero) return;
        this.animated = true;

        const elements = [this.label, this.title, this.description].filter(Boolean);

        if (elements.length === 0) return;

        // Calculate stagger to start when previous animation is almost complete (85% of duration)
        const stagger = this.options.duration * 0.55;

        // Create timeline for sequential animation
        const tl = gsap.timeline();

        elements.forEach((element, index) => {
            tl.to(element, {
                opacity: 1,
                y: 0,
                duration: this.options.duration,
                ease: 'power2.out'
            }, index * stagger);
        });
    }
}

